module.exports = __webpack_public_path__ + "static/img/user.03878aba.png";